import(/* webpackMode: "eager" */ "/var/www/website/boatzon-video-call/app/page.tsx");
